<template>
  <div class="promotion-page">
    <div class="page-header">
      <h1 class="page-title">รายการโปรโมชั่นสุดพิเศษ</h1>
    </div>

    <div class="page-content">
      <div class="promotion-grid">
        <!-- Dynamic User Promotion Card (from API based on promo_id) -->
        <div v-if="userPromotion" class="promotion-card">
          <div class="card-image">
            <img
              :src="cdnImage(`kaiju/promotions/free-${userPromoTotal}.jpg`)"
              alt="Promotion"
              class="promo-img"
            />
          </div>
          <div class="card-content">
            <div class="content-row">
              <h3 class="card-title">{{ userPromotion.title }}</h3>
            </div>
            <div class="content-row">
              <p class="card-teaser">
                รับโบนัสฟรี {{ userPromoTotal }}บาท
                เมื่อสมัครสมาชิกเสร็จเรียบร้อย
              </p>
            </div>
            <div class="content-row button-row">
              <button class="info-btn" @click="showUserPromoModal">
                ดูรายละเอียด
              </button>
            </div>
          </div>
        </div>

        <!-- Marketing cards from the promotion_displays API (Backoffice-managed) -->
        <div
          v-for="promo in displayCards"
          :key="promo.key"
          class="promotion-card"
        >
          <div v-if="promo.imageSrc" class="card-image">
            <img :src="promo.imageSrc" :alt="promo.title" class="promo-img" />
          </div>
          <div class="card-content">
            <div class="content-row">
              <h3 class="card-title">{{ promo.title }}</h3>
            </div>
            <div v-if="promo.teaser" class="content-row">
              <p class="card-teaser">{{ promo.teaser }}</p>
            </div>
            <div class="content-row button-row">
              <button class="info-btn" @click="showPromoModal(promo)">
                ดูรายละเอียด
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Promotion Modal -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-body">
          <div v-if="selectedPromo.imageSrc" class="modal-image">
            <img
              :src="selectedPromo.imageSrc"
              :alt="selectedPromo.title"
              class="modal-promo-img"
            />
          </div>
          <div class="modal-details">
            <h2 class="modal-title">{{ selectedPromo.title }}</h2>
            <div
              class="modal-description"
              v-html="selectedPromo.description"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserData } from '@/auth/utils'
import getCurrentDomain from '@/utils/domain'
import { cdnImage } from '@/utils/cdn'

// Shown only when the promotion-displays API errors or returns no rows —
// identical to the cards that were hardcoded here before the page became
// API-driven (Backoffice → agent Detail → โปรโมชั่นหน้าเว็บ).
const FALLBACK_CARDS = [
  {
    key: 'fallback-first',
    title: 'ฝากครั้งแรกของวัน รับเพิ่ม 50%',
    modalTitle: 'ฝากครั้งแรกของวัน รับสูงสุด 500 บาท',
    teaser:
      'โบนัสฝากครั้งแรกประจำวัน รับโบนัสสูงสุด 500 บาท พร้อมเงื่อนไขที่คุ้มค่า',
    image: 'first.jpg',
    description: `
      <div class="promo-description">
        <h4>เงื่อนไขโปรโมชั่น:</h4>
        <ul>
          <li>ฝากเงินขั้นต่ำ 100 บาท</li>
          <li>รับโบนัส 50% สูงสุด 500 บาท</li>
          <li>โบนัสสามารถถอนออกได้หลังจากเล่นครบ 6 เทิร์น</li>
          <li>ถอนสูงสุด 4 เท่า</li>
          <li>โปรโมชั่นนี้สามารถรับได้ 1 ครั้งต่อวัน</li>
          <li>เล่นได้เฉพาะสล็อต ห้ามซื้อฟรีสปิน</li>
        </ul>
      </div>
    `
  },
  {
    key: 'fallback-golden',
    title: 'นาทีทอง รับเพิ่ม 3เท่า สุงสุด 3,000บาท',
    modalTitle: 'โปรโมชั่นนาทีทอง รับเพิ่ม 3 เท่า',
    teaser:
      'โปรโมชั่นพิเศษในช่วงเวลา 20:00-21:00 น. ทุกวัน รับโบนัสพิเศษเฉพาะช่วงนาทีทอง',
    image: 'golden.jpg',
    description: `
      <div class="promo-description">
        <h4>เงื่อนไขโปรโมชั่น:</h4>
        <ul>
          <li>รับได้ 3 ช่วงเวลา เลือกได้ที่หน้าฝากเงิน</li>
          <li>ฝากเงินขั้นต่ำ 100 บาท รับโบนัสสูงสุด 3,000</li>
          <li>ทำยอด 6 เท่า</li>
          <li>ถอนสูงสุด 4 เท่า</li>
          <li>เล่นได้เฉพาะสล็อต ห้ามซื้อฟรีสปิน</li>
        </ul>
      </div>
    `
  },
  {
    key: 'fallback-cashback',
    title: 'คืนยอดเสีย 5% กดรับได้ทุกวัน หลัง 00:15น',
    modalTitle: 'คืนยอดเสีย 5% กดรับได้ทุกวัน หลัง 00:15น',
    teaser: 'รับเงินคืนจากยอดเสีย 5% ทุกวัน หลัง 00:15น สูงสุด 300 บาทต่อวัน',
    image: 'cashback.jpg',
    description: `
      <div class="promo-description">
        <h4>เงื่อนไขโปรโมชั่น:</h4>
        <ul>
          <li>ระบบจะคืนยอดเสียอัตโนมัติ 5% ทุกวัน หลัง 00:15น</li>
          <li>ยอดเสียคืนสูงสุดต่อวัน 500 บาท</li>
          <li>โบนัสสามารถถอนออกได้หลังจากเล่นครบ 1 เทิร์น</li>
          <li>รับได้ขั้นต่ำ 5บาท</li>
          <li>ถอนสูงสุด 1,500 บาท</li>
        </ul>
      </div>
    `
  }
]

export default {
  name: 'PromotionPage',
  data() {
    return {
      showModal: false,
      selectedPromo: {},
      displayPromotions: [],
      userPromotion: null
    }
  },
  computed: {
    userPromoId() {
      const userData = getUserData()
      return userData?.promo_id || null
    },
    userPromoTotal() {
      if (!this.userPromotion) return 0
      return this.userPromotion.minimum_deposit + this.userPromotion.value
    },
    displayCards() {
      if (this.displayPromotions.length > 0) {
        return this.displayPromotions.map(promo => ({
          key: `api-${promo.id}`,
          title: promo.title,
          modalTitle: promo.title,
          teaser: promo.teaser || '',
          // Full R2/CDN URL straight from the DB — never through cdnImage()
          imageSrc: promo.image_url || '',
          description:
            promo.detail || (promo.teaser ? `<p>${promo.teaser}</p>` : '')
        }))
      }
      return FALLBACK_CARDS.map(card => ({
        ...card,
        imageSrc: cdnImage(`kaiju/${card.image}`)
      }))
    }
  },
  mounted() {
    this.fetchDisplayPromotions()
    this.fetchUserPromotion()
  },
  methods: {
    cdnImage,
    async fetchDisplayPromotions() {
      try {
        const response = await this.$http.post('/internal/promotion-displays', {
          domain: getCurrentDomain()
        })
        const rows = response?.data?.success ? response.data.data : []
        this.displayPromotions = Array.isArray(rows) ? rows : []
      } catch (error) {
        console.error('Failed to fetch promotion displays:', error)
        this.displayPromotions = []
      }
    },
    async fetchUserPromotion() {
      if (!this.userPromoId) return
      try {
        const response = await this.$http.post(
          '/internal/agent/promotions/type',
          {
            domain: getCurrentDomain(),
            type: 'free'
          }
        )
        const promos = Array.isArray(response?.data) ? response.data : []
        this.userPromotion =
          promos.find(promo => promo.id === this.userPromoId) || null
      } catch (error) {
        console.error('Failed to fetch promotions:', error)
      }
    },
    showUserPromoModal() {
      if (!this.userPromotion) return
      this.selectedPromo = {
        title: this.userPromotion.title,
        imageSrc: cdnImage(`kaiju/promotions/free-${this.userPromoTotal}.jpg`),
        description: `
          <div class="promo-description">
            <h4>เงื่อนไขโปรโมชั่น:</h4>
            <ul>
              <li>ฟรีเครดิตเมื่อสมัครสำเร็จ</li>
              <li>เล่นได้เฉพาะสล็อต</li>
              <li>ห้ามซื้อฟรีสปิน</li>
            </ul>
            <p style="background: rgba(239, 68, 68, 0.15); border: 1px solid rgba(239, 68, 68, 0.3); border-radius: 6px; padding: 8px 12px; color: #fca5a5; font-size: 0.85rem; margin-top: 12px;"><strong style="color: #ef4444;">⚠️ ข้อห้าม:</strong> 1คน ต่อ 1บัญชี ห้ามสมัครหลายบัญชีเพื่อรับโปรนี้</p>
          </div>
        `
      }
      this.showModal = true
    },
    showPromoModal(promo) {
      this.selectedPromo = {
        title: promo.modalTitle || promo.title,
        imageSrc: promo.imageSrc,
        description: promo.description
      }
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.selectedPromo = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.promotion-page {
  width: 100%;
  padding: 5px;
}

.page-header {
  display: flex;
  padding: 15px 10px;
  margin-bottom: 5px;
}

.page-title {
  font-size: clamp(1.8rem, 4vw, 2.5rem);
  font-weight: 400;
  color: #ffcc00;
  text-align: center;
  margin: 0;

  @media (max-width: 768px) {
    font-size: clamp(1.7rem, 5vw, 2rem);
  }

  @media (max-width: 480px) {
    font-size: clamp(1.5rem, 4vw, 1.8rem);
  }
}

.page-content {
  max-width: 1200px;
  margin: 0 auto;
}

.promotion-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 768px) {
    gap: 15px;
  }
}

.promotion-card {
  display: flex;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  animation: cardFadeIn 0.6s ease-out;
  min-height: 150px;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(255, 204, 0, 0.2);
    border-color: rgba(255, 204, 0, 0.3);
  }

  @media (max-width: 768px) {
    min-height: 120px;
  }
}

.card-image {
  flex: 3;
  min-width: 120px;
  position: relative;
  overflow: hidden;

  @media (max-width: 480px) {
    flex: 2;
    min-width: 100px;
  }
}

.promo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
}

.card-content {
  flex: 9;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 12px;
  }
}

.content-row {
  display: flex;
  flex-direction: column;
}

.card-title {
  color: #ffcc00;
  font-size: 18px;
  font-weight: 300;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 17px;
  }

  @media (max-width: 480px) {
    font-size: 15px;
  }
}

.card-teaser {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  line-height: 1.5;
  margin: 8px 0 0 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
}

.button-row {
  justify-content: flex-end;
  align-items: flex-end;
  flex: 1;
  margin-top: 10px;
}

.info-btn {
  background: linear-gradient(45deg, #ffcc00, #ff9900);
  color: #000;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover {
    background: linear-gradient(45deg, #ff9900, #ffcc00);
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(255, 204, 0, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 14px;
  }

  @media (max-width: 480px) {
    padding: 6px 12px;
    font-size: 13px;
  }
}

// Modal Styles
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 15px;
}

.modal-content {
  background: linear-gradient(
    135deg,
    rgba(16, 16, 30, 0.95),
    rgba(26, 26, 46, 0.95)
  );
  border-radius: 20px;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  animation: modalFadeIn 0.3s ease-out;

  @media (max-width: 768px) {
    max-width: 95%;
    border-radius: 15px;
  }
}

.modal-body {
  display: flex;
  padding: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px;
  }
}

.modal-image {
  flex: 4;
  margin-right: 30px;

  @media (max-width: 768px) {
    flex: none;
    margin-right: 0;
    margin-bottom: 20px;
  }
}

.modal-promo-img {
  width: 100%;
  height: auto;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.modal-details {
  flex: 6;

  @media (max-width: 768px) {
    flex: none;
  }
}

.modal-title {
  color: #ffcc00;
  font-size: 24px;
  font-weight: 300;
  margin: 0 0 20px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 15px;
  }
}

.modal-description {
  color: rgba(255, 255, 255, 0.9);

  :deep(.promo-description) {
    h4 {
      color: #ffcc00;
      font-size: 18px;
      font-weight: 300 !important;
      margin: 0 0 15px 0;

      @media (max-width: 768px) {
        font-size: 16px;
      }
    }

    ul {
      margin: 10px 0 20px 20px;
      padding: 0;

      li {
        margin-bottom: 8px;
        line-height: 1.6;
        color: rgba(255, 255, 255, 0.8);

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    p {
      line-height: 1.7;
      margin-bottom: 15px;
      color: rgba(255, 255, 255, 0.8);

      strong {
        color: #ffcc00;
      }
    }
  }
}

@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style>
